module.exports = __webpack_public_path__ + "img/weixin.fa41ec46.png";